import { forwardRef, useContext } from '@wordpress/element';
import { Context } from './context';
import * as Styled from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const ItemLabel = forwardRef(function UnforwardedItemLabel(props, ref) {
  const menuContext = useContext(Context);
  if (!menuContext?.store) {
    throw new Error('Menu.ItemLabel can only be rendered inside a Menu component');
  }
  return /*#__PURE__*/_jsx(Styled.ItemLabel, {
    numberOfLines: 1,
    ref: ref,
    ...props
  });
});